import ContentPage from "./ContentPage";

export default function Shipping() {
  return (
    <ContentPage title="Shipping & returns" eyebrow="Policies">
      <p className="lead">
        We aim to dispatch in-stock orders quickly and communicate tracking as soon as your package ships.
      </p>
      <h2>Shipping</h2>
      <p>
        Rates and delivery windows depend on your location and selected service. Free shipping may apply on qualifying cart totals as shown at checkout.
      </p>
      <h2>Returns</h2>
      <p>
        Unused items in original condition may be returned within the window stated in your order confirmation. Final sale items will be marked clearly at purchase.
      </p>
    </ContentPage>
  );
}
